import Styles from '../PropertyForm.module.scss'

interface Props {
  isValid: boolean
}

const Text = ({ isValid }: Props) => {
  return (
    <div className={Styles.textSubsection}>
      <div className={Styles.sectionSubheader}>A property that you can set with any text value.</div>
    </div>
  )
}

export default Text
